<template>
  <div :class="[isActive?'':'container payment']">
    <div style="background:#fff">
      <swiper :options="swiperOption" ref="mySwiper" id="mySwiper" class="membership">
        <swiper-slide class="swiper-item" v-for="(item,index) in list" :key="item.id" >
          <div :class="[isSelect===item.id?'select':'item']" @click="()=>handleSelect(item)">
            <div v-if="item.title" class='select-event'>{{item.title}}</div>
            <div class="name">{{item.name}}</div>
            <div class="price">￥{{item.buyPrice}}</div>
            <div class="origin-price" v-if="item.originalPrice !== item.buyPrice">￥{{item.originalPrice}}</div>
            <div v-if="getEconomize(item)>0" :class="[isSelect===item.id?'select-economize':'economize']"  class="economize">立省￥{{getEconomize(item)}}</div>
          </div>
        </swiper-slide>
        <div @click="handlePrev" v-if="list.length>3" class="swiper-button-prev" slot="button-prev"><</div>
        <div @click="handleNext" v-if="list.length>3" class="swiper-button-next" slot="button-next">></div>
      </swiper>
      <div class="description">
        <div>会员服务期限的说明：</div>
        <div>•1个月会员服务时长：31天 </div>
        <div>•1年会员服务时长（基于每月31天计算）：372天</div>
      </div>
    </div>

    <div class="pay-box">
      <div style="width: 200px;padding:30px 40px" v-if="selected===1" id="qrcode" ref="qrcode" class="allse"></div>
      <img v-else style="margin:30px 20px" :src="require('../../../assets/images/purchase/pay-bg.jpg')" width="200px"/>
      <div style="text-align: left;width: 100%">
        <div class="public-box" @click="handlePublic">我要对公转账 ＞ </div>
        <div style="text-align: left;color: #000000;font-size: 16px;margin-top: -20px;">选择支付方式</div>
        <div style="display: flex;margin-top: 6px;color:#000000">

          <div v-if="wx" style="margin-right: 8px" :class="[selected===1?'select-payment':'payment-box']" @click="()=>handleClick(1)">
            <img src="../../../assets/images/wechat.png" style="width:12px;margin-right: 12px">
            微信支付
<!--            <div id="qrcode" ref="qrcode" class="allse"></div>-->
          </div>
          <div v-if="zfb" style="margin-right: 8px" :class="[selected===2?'select-payment':'payment-box']" @click="( )=>handleClick(2)">
            <img src="../../../assets/images/alipay.png" style="width:12px;margin-left: 2px;margin-right: 12px">
            支付宝支付
          </div>
          <div v-if="amount&&token" :class="[selected===3?'select-payment':'payment-box']" @click="( )=>handleClick(3)">
            账户余额<span>￥{{cashaccount}}</span>
          </div>
        </div>


        <span slot="footer" class="dialog-footer">
      <div class="pay-price">￥{{price}}<span class="pay-economize" v-if="type!=='1'&&economizePrice">已减{{economizePrice}}，仅需{{dailyMoney||0}}元/天</span></div>
      <el-button class="pay-btn" @click="handleSure">{{ selected===1?'扫码支付':'立即支付' }}</el-button>
             <div style="margin-bottom: 14px">
          <el-checkbox v-model="checked">同意并接受 </el-checkbox>
          <span class="agreement" @click="handleJump" style="margin-left: 12px">个人订阅服务协议</span>
        </div>
    </span>
      </div>
    </div>
    <PublicTransfer :detail="publicDetail" :dialog-visible="publicDialogVisible" @cancel="publicDialogVisible=false"/>
    <el-dialog append-to-body width="424px" class="dialog-bg" :visible.sync="modelShow" :close-on-click-modal="true" :close-on-press-escape="true">
      <denlyx :loginType="1" ref='mychild' @immediatelyData="immediatelyData"/>
    </el-dialog>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import QRCode from "qrcodejs2";
import { setToken, removeToken,getToken } from "@/utils/auth";
import denlyx from '../../../components/denlu/zhesdengl'
import PublicTransfer from './public-transfer';

import {
  getMembershipList,
  getPayment,
  getPaymentMethod, getPublicPay,
  getWxPay,
  testApi
} from '../../../api/accept/purchase-membership';
import { AssetInfoEmp } from '../../../api/employer/user/user';
import { Accesstoimage, GetQRcode } from '../../../api/projectSquare/xmgc';

export default {
  components: {
    swiper,
    swiperSlide,
    denlyx,
    PublicTransfer
  },
  props:{
    isActive:Boolean,
    type:String
  },
  data(){
    return {
      memberType:{
        '1':'体验会员',
        '2':'Kepler VIP会员',
        '3':'Kepler SVIP会员'
      },
      modelShow: false,
      selected: 0,
      checked: false,
      isSelect: '',
      price: '',
      economizePrice:'',
      list: [],
      url: '',
      cashaccount: '0.00',
      publicDialogVisible:false,
      publicDetail:{},
      token:getToken(),
      zfb:false,
      wx:false,
      amount:false,
      tanchu: 0,
      Whether:false,
      usertypeasd:'',
      dailyMoney:'',
      swiperOption: {
        pagination: {
          el: ".case-swiper-pagination"
          //区分不同Swiper的组件
        },
        mousewheel:{
          invert:false
        },

        //设置平滑
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }
  },
  watch:{
    type:{
      handler(newVal){
        console.log(newVal)
        this.getMemberShip(newVal)
      },
      deep:true,
      immediate:true
    }
  },
  computed:{
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    this.getPaymentM()
    let token = this.$route.query.token

    if(token){
      sessionStorage.setItem('token',token)
      sessionStorage.setItem("is_login", "true");
      this.url=this.$route.query.url
      this.$emit('header', false)
      // setTimeout(()=>{
      // console.log(sessionStorage.getItem('token'),'sessionStorage')

      // },9000)
    }else{
      this.url=window.location.origin+'/paymentSuccess.html'
    }

  },
  mounted() {
    this.getList()
  },
  methods:{
    creatQrCode() {
      getWxPay(this.isSelect).then((response) => {
        // console.log(response,"二维码")
        this.$refs.qrcode.innerHTML = ""; //清除二维码方法一
        let text = response.data;
        // localStorage.setItem("paymentScene", JSON.stringify(response.data));
        var qrcode = new QRCode(this.$refs.qrcode, {
          text: text, //页面地址 ,如果页面需要参数传递请注意哈希模式#
          width: 160,
          height: 160,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        // let scene = JSON.parse(localStorage.getItem("paymentScene"));
        // 需要消息的推送，则创建连接
        this.createWebSocket();
      }).catch((response) => {
      });
    },

    // 与websocket服务器创建连接
    createWebSocket(userId) {

      let websocket = new WebSocket(
        process.env.WebSocket_ROOT + "webSocket/" + localStorage.getItem("userId")
      );
      // 连接成功时
      websocket.onopen = () => {
        websocket.send('hello')
      };
      websocket.onmessage = (event) => {
        if(event.data==='SUCCESS'){
          this.$alert(`恭喜您已开通${this.memberType[this.type]}！`, '', {
            confirmButtonText: '确定',
            center: true,
            showClose:false,
            confirmButtonClass:'confirmButton'
          }).then(()=>{
            location.href='/purchaseMembership'
          });
          websocket.close();
          // this.creatQrCode()
        }

      };
      websocket.onerror=(error)=>{
        console.log(error,'连接失败')
      };
      websocket.onclose = function () {
        console.log("关闭了");
      };
      // // 路由跳转时结束websocket链接
      this.$router.afterEach(function () {
        websocket.close();
      });
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常
      window.onbeforeunload = function () {
        websocket.close();
      };
    },


   async handlePublic(){
     if(!this.token&&!this.$route.query.token){
       this.tabchuyg()
       return
     }
      const res=await getPublicPay({productId: this.isSelect })
      this.publicDetail=res.data
      this.publicDialogVisible=true;

    },
    // 登录注册开始
    immediatelyData(artlf) {
      this.tanchu = artlf
    },


    getEconomize(item){
      return item.originalPrice-item.buyPrice
    },
    handlePrev(){
      this.swiper.slidePrev()
    },
    handleNext(){
      this.swiper.slideNext()
    },
    async getList(){
      if(this.token){
        const res2=await AssetInfoEmp()
        this.cashaccount=res2.data.cashaccount
      }
      await this.getMemberShip()

    },
    async getPaymentM(){
      const res=await getPaymentMethod();
      this.selected=2;
      this.zfb=res.data[0].switchConfig;
      this.wx=res.data[1].switchConfig;
      this.amount=res.data[2].switchConfig;
    },
    async getMemberShip(val){
      const res=await getMembershipList({levelSign:val?val:   this.type})
      this.list=res.data
      this.isSelect=this.list[0].id
      this.price=this.list[0].buyPrice

      this.economizePrice=this.list[0].originalPrice-this.list[0].buyPrice
      this.dailyMoney=this.list[0].dailyMoney
    },
    handleSelect(item){
      this.price=item.buyPrice
      this.economizePrice=item.originalPrice-item.buyPrice
      this.dailyMoney=item.dailyMoney
      this.isSelect=item.id
    },

    async handleClick(val){
      if(!this.checked){
        this.$message.warning('需同意并接受个人订阅服务协议')
        return
      }
      this.selected=val
      if(val===1){
        if(!this.token&&!this.$route.query.token){

          this.tabchuyg()
          return
        }
        this.creatQrCode()
        // const res= await getWxPay(this.isSelect)
      }

    },
    handleJump(){
      let routeData=this.$router.resolve({path:'/privacy'})
      window.open(routeData.location.path,'_blank')
      // this.$router.push("/privacy");
    },
    tabchuyg() {
      this.modelShow = true;
      this.$nextTick(() => {
        this.$refs.mychild.creatQrCode();
      })

    },
    async handleSure(){
      if(!this.token&&!this.$route.query.token){

        this.tabchuyg()
        return
      }
      if(!this.checked){
        this.$message.warning('需同意并接受个人订阅服务协议')
        return
      }
      if(this.selected){
        if(this.selected===3){
          await getPayment({productId: this.isSelect })
          this.$emit('cancel')
          this.$message.success('支付成功')
          if(this.$route.query.token){
            window.open(this.url,'_blank')
          }else{
            location.href = '/';
          }

        }else if(this.selected===2){
          const res= await testApi({productId: this.isSelect,url:this.url });
          document.write(res.data);
        }

        this.getList();
        // this.visible=false;
        // this.$emit('sure',this.selected)
      }else{
        this.$message.warning('请选择任一支付方式')
      }

    },
  }
}
</script>
<style scoped>
.dialog-bg{
  background: rgba(0,0,0,0.5)
}
/deep/ .el-dialog{
  background:#ffffff;
}
/deep/ .el-dialog__body{

}
.swiper-button-prev{
  width: 55px;
  height: 55px;
  background: #FFFFFF;
  border-radius: 50%;
  font-size: 30px;
  color: #656565;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
}
.public-box{
  text-align: right;
  color: #000;
  font-size: 16px;
  margin-top: 8px;
  cursor: pointer;
}
.swiper-button-next{
  width: 55px;
  height: 55px;
  background: #FFFFFF;
  border-radius: 50%;
  font-size: 30px;
  color: #656565;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
}
.economize{
  color: #636363;
  font-size: 16px;
  margin-top:6px;
}
.select-economize{
  width: 140px;
  height: 24px;
  background: #FFFFFF;
  border-radius: 14px;
  line-height: 24px;
  color: #FF0000;
  font-size: 16px;
  margin-top:6px;
}
.description{
  text-align: left;
  margin-left:25px;
  padding-bottom: 12px;
  font-size:12px;
}
.payment{
  display: flex;
  flex-direction: column;
  width: 680px;
  background-color: #ffffff;
  padding-top:25px;
  padding-bottom: 25px;


}
.membership{
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  padding: 32px 25px 12px;

}
.box{
  width: 100%;
  background-color: #ffffff;
  padding:40px;

}
.title{
  font-size: 64px;
  font-weight: bold;
  margin-bottom: 28px;
}
.item{
  padding:20px;
  cursor: pointer;
  /*width: 150px !important;*/
  height: 200px;
  background: #FFFFFF;
  border-radius: 10px;
  border: 2px solid #CDCDCD;
  opacity: 0.78;
  position: relative;

}
.swiper-item{
  width: 180px !important;
  margin-right: 30px;
}
.select-event{
  position: absolute;
  width: 119px;
  height: 30px;
  background: linear-gradient(91deg, #FD6B00, #FF003C);
  border-radius: 16px 3px 16px 3px;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 30px;
  top: -10px;
  left: -1px;
}
.event{
  position: absolute;
  width: 116px;
  height: 24px;
  background: linear-gradient(91deg, rgba(104,186,253,0.5), rgba(102,0,255,0.5));
  border-radius: 9px 0px 9px 0px;
  font-size: 20px;
  color: #673300;
  line-height: 24px;
  top: -10px;
  left: -1px;
}
.confirmButton{
  width: 120px;
  height: 40px;
  background: #FAC67D;
  border-radius: 20px;
}
.select{
  position: relative;

  /*width: 150px !important;*/
  height: 200px;
  border-radius: 8px;
  padding:20px;
  background: linear-gradient(91deg, rgba(104,186,253, 0.48), rgba(102,0,255,0.48));
  border: 1px solid rgba(242, 148, 7, .64);
}
.name{
  font-size: 24px;
  font-weight: bold;
  margin-top:40px;
  color: #000000;
}
.price{
  font-size: 30px;
  font-weight: bold;
  margin-top:16px;
  color: #000000;
}
.pay-box{
  margin-top: 2px;
  border-radius: 8px;
  background:#ffffff;
  display: flex;
}
.origin-price{
  text-decoration: line-through;
  font-size: 14px;
  color: #949393;
  margin-top:8px
}
.btn{
  margin-top:36px;
}
.payment-box{
  width: 120px;
  height: 12px;
  border:1px solid rgba(0, 0, 0, .12);
  border-radius: 4px;
  padding:8px;
  text-align: left;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  cursor: pointer;
}
.select-payment{
  width: 120px;
  height: 12px;
  border-radius: 4px;
  padding:8px;
  text-align: left;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
  cursor: pointer;

  /*background: linear-gradient(214deg, #ffe4a9, #fffdf0);*/
  /*border: 1px solid rgba(242, 148, 7, .64);*/
  background: linear-gradient(91deg, rgba(104, 186, 253, 0.48), rgba(102, 0, 255, 0.48));
  border: 1px solid rgba(242, 148, 7, .64);
}
.agreement{
  cursor:pointer;
}
.pay-price{
  font-weight: bold;
  font-size: 28px;
  margin-right: 20px;
  margin-bottom: 4px;
  color: #FF1200
}
.pay-economize{
  color: #BB1904;
  font-size: 16px;
  margin-left: 20px;
  margin-bottom: 4px;
}
.pay-btn{
  margin-bottom: 6px;
  background:linear-gradient(91deg,#FD6B00,#FF063C);
  color: #ffffff;
  font-size: 18px;
  width: 230px;
  height: 48px;
  border-radius: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/accept/purchase-membership/method.vue